import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../services/configuration.service';

@Injectable()
export class EnvironmentInterceptor implements HttpInterceptor {
  private configurationService = inject(ConfigurationService);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const client = this.configurationService.environment;

    req = req.clone({
      setHeaders: {
        client,
        'gs-pv-env': this.configurationService.provenueEnvironment,
      },
    });

    return next.handle(req);
  }
}
